import { action } from 'satcheljs';
import type { WindowKey } from 'owa-bizchat-types';

export interface BizChatConversationIdChangedMessage {
    windowKey: WindowKey;
    conversationId: string;
}

/**
 * Dispatched whenever the BizChat iframe reports a new or changed conversation ID.
 * Consumers can orchestrate against this to detect conversation resets.
 */
export const bizChatConversationIdChanged: ReturnType<typeof action> = action(
    'bizChatConversationIdChanged',
    (windowKey: WindowKey, conversationId: string): BizChatConversationIdChangedMessage => ({
        windowKey,
        conversationId,
    })
);
